import React from "react";
// Be sure to include styles at some point, probably during your bootstraping
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import Navigation from "./Navigation";
import "./public/css/LeftMenuTemplate.scss";
import BreadCrumbs from "./BreadCrumbs";
import OperationButtons from "./OperationButtons";
import SideNavigation from "./SideNavigation";
export default class LeftMenuTemplate extends React.Component {  
  constructor(props) {
    super(props);
    this.core = this.props.core;
    this.appId = this.props.appId;
    this.params = this.props.params;
    this.proc = this.props.proc;
    this.config = this.props.config;
    this.keepExpanded = this.props.keepExpanded;
    this.navigation = React.createRef();
    this.operationButtonsRef = React.createRef();
    this.appNavigationDiv = "navigation_" + this.appId;
    this.state = {
      menus: this.props.menus ? this.props.menus : [],
      selected: "",
      expanded: this.keepExpanded ? true : false,
      // operationButtons: [],
    };
    // this.setOperationButtons = this.setOperationButtons.bind(this);
    // this.updateState = this.updateState.bind(this);
    this.leftMenuTemplateId = `left-navigation-${this.appId}`;
  }

  menuSelect = (data) => {
    if (this.state.selected.page_id !== data.selected.page_id) {
      this.setState({ ...data });
      document.getElementById(this.appNavigationDiv).dispatchEvent(new CustomEvent("clearBreadCrumbs"));
      document.getElementById(this.appNavigationDiv).dispatchEvent(new CustomEvent("resetOperationButtons"));
    }
  };

  updateState = (data) => {
    this.setState({ ...data });
  };

  onSelect = (selected) => {
    this.navigation.current.reloadExistingPage();
    if (selected?.page_id === this.state.selected?.page_id) return;
    this.navigation.current.resetPageCustomActions();
    this.setState({
      selected: selected,
      expanded: this.keepExpanded ? true : false,
    });
  }


  render() {
    return (
      <div className={"LeftMenuTemplate" + (this.props.proc.metadata.hideMenu ? " hideMenu" : "")} id={this.leftMenuTemplateId}>
        <SideNavigation menus={this.state.menus} updateMenu={this.menuSelect} selected={this.state.selected}/>
        <div className="NavigationContainer">
          <div id="NavigationHeaderContainer_tempId" className="NavigationHeaderContainer">
            <BreadCrumbs core={this.core} appNavigationDiv={this.appNavigationDiv} />
            {this.navigation.current && <OperationButtons navigationRef={this.navigation} appNavigationDiv={this.appNavigationDiv} />}
          </div>
          <Navigation
            ref={this.navigation}
            core={this.core}
            params={this.params}
            config={this.config}
            menus={this.state.menus}
            menuLoad={(i) => this.updateState({ menus: i })}
            selectLoad={(i) => this.updateState({ selected: i })}
            onSelect={this.onSelect}
            appId={this.appId}
            proc={this.proc}
            selected={this.state.selected}
          />
        </div>
      </div>
    );
  }
}
